import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/globals.css'
import { registerServiceWorker } from '@/utils/serviceWorker'
import { initPreloadManager } from '@/utils/preloadStrategy'
import type { FontTheme } from '@/hooks/useFont'

// 許可するフォントテーマ（不正値は既定にフォールバック）
const VALID_FONT_THEMES: readonly FontTheme[] = ['lato', 'outfit'];
const DEFAULT_FONT_THEME: FontTheme = 'lato';

// Set default font theme
if (typeof window !== 'undefined') {
  const savedFont = localStorage.getItem('font-theme');
  const fontTheme = VALID_FONT_THEMES.includes(savedFont as FontTheme)
    ? (savedFont as FontTheme)
    : DEFAULT_FONT_THEME;
  document.body.classList.add(`theme-${fontTheme}`);
}

// Service Worker登録（本番環境のみ）
if (import.meta.env.PROD) {
  registerServiceWorker({
    onUpdate: (_registration) => {
      console.log('New version available! Reload to update.')
      // 必要に応じて更新通知UIを表示
    },
    onSuccess: () => {
      console.log('Service Worker registered successfully')
    },
    debug: import.meta.env.DEV
  })
}

// プリロードマネージャー初期化
const preloadManager = initPreloadManager({
  batchSize: 3,
  respectNetworkStatus: true,
  debug: import.meta.env.DEV
})

// 重要なリソースをプリロード（本番環境のみ）
if (import.meta.env.PROD) {
  preloadManager.preloadCritical([
    { url: '/assets/react-core.js', type: 'script', priority: 'high' },
    { url: '/assets/styles/index.css', type: 'style', priority: 'high' }
  ])
  
  // DNS プリフェッチ
  preloadManager.dnsPrefetch([
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com'
  ])
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

// Dev banner: 必読ドキュメント周知（本番では抑制）
if (import.meta.env.DEV) {
  console.log('%cREAD FIRST: docs/WORLD_CLASS_ART_DIRECTION.md', 'color:#fff;background:#111;padding:6px 10px;border-radius:4px;');
}